<template>
  <b-card header-tag="header">
    <h3 slot="header">Student Volunteer Application</h3>
    <h4 v-if="isLoading">Getting your application...</h4>
    <div class="card-text" v-if="isLoaded">
      <div v-if="isNewApp" class="row">
        <div v-if="isTeamLeader" class="col">
        </div>
        <div v-else class="col">
          <h2>Applications Have Closed</h2>
          <p>The deadline for submissions has passed and we are now processing completed applications.</p>
        </div>
      </div>
      <div v-if="completed" class="row">
        <div v-if="isAccepted && !isTeamLeader" class="col">
          <h2 class="mb-2">Welcome to the SIGGRAPH SV Family!</h2>
          <p>Congratulations on being accepted as a Student Volunteer for this year's conference!</p>
          <p>This page will be your Dashboard where you can access Scheduling features in the near future.</p>
          <!-- <p>If you've applied for financial assistance, you'll be notified via email if you are granted funds.
            You can also check back here to see updates.</p>-->
          <p>If for some reason you are unable to attend, you can decline your position.</p>
          <button type="button" @click="declineAcceptance" class="btn btn-lg btn-block">Decline
            Position</button>
        </div>
        <div v-if="isTeamLeader" class="col">
          <h2 class="mb-2">Welcome to the SIGGRAPH SV Family!</h2>
          <p>Congratulations on being accepted as a Team Leader for this year's conference!</p>
          <p>This page will be your Team Leader Dashboard where you can access Jury and Scheduling features.</p>
        </div>
        <div v-if="isOffered && !isTeamLeader" class="col">
          <div v-if="isAfterConfirmationDeadline">
            <h2>The confirmation deadline has passed.</h2>
            <p>The acceptance confirmation deadline for first round acceptances was <strong>June 29th, 22:00 UTC/GMT</strong>. If you have questions please email <a href="mailto:sv-s2024@siggraph.org">sv-s2024@siggraph.org</a>.</p>
          </div>
          <div v-else>
            <h2>Congratulations!<br />You've been accepted as a Student Volunteer!</h2>
            <p>Now that you've been accepted, we need your confirmation of attendence.</p>
            <p>Please spend some time on this confirmation form so we know that you're able to come.
              This will also help us better accomodate you and make sure you have a great experience at SIGGRAPH.</p>
            <p>Please confirm or decline your position no later than <strong>June 29th, 22:00 UTC/GMT</strong>.</p>
            <div class="row justify-content-center">
              <div class="col-4">
                <button type="button" @click="goToConfirmationForm" class="btn btn-lg btn-block">Confirm</button>
              </div>
              <div class="col-4">
                <button type="button" @click="declineAcceptance" class="btn btn-lg btn-block">Decline</button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isDeclined" class="col">
          <h2 class="mb-2">Sorry you aren't able to make it!</h2>
          <p>You've declined the invitation to be a Student Volunteer. If this is a mistake, please contact us immediately
            at <a href="mailto:sv-s2024@siggraph.org">sv-s2024@siggraph.org</a>.</p>
          <p>The deadline for confirmations was <strong>Thursday, June 20th</strong>.</p>
        </div>
        <div v-if="isPending && !isTeamLeader" class="col">
          <h2>Thank You For Applying!</h2>
          <p>You have successfully applied to the SIGGRAPH Student Volunteer Program.</p>
          <p>The deadline for submissions has passed and we are now processing completed applications.</p>
          <h3>Notification of Acceptance</h3>
          <p>You should hear from us around the following time:</p>
          <p><strong>May 2024</strong></p>
          <h3>Professional References</h3>
          <p>References will be contacted shortly after applications close. Please allow a few days for forms to be sent.
          </p>
        </div>
      </div>
      <div v-else>
        <div class="row">
          <div v-if="isTeamLeader" class="col">
            <h2>Welcome to the SIGGRAPH SV Family!</h2>
            <p>Congratulations on being accepted as a Team Leader for this year's conference!</p>
            <p>This page will be your Team Leader Dashboard where you can access Jury and Scheduling features.</p>
          </div>
          <div v-else-if="!isNewApp" class="col">
            <h2>Applications Have Closed</h2>
            <p>The deadline for submissions has passed.</p>
            <p>We begin processing completed applications immediately and we cannot accept late submissions.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="row" :style="{ 'margin-top': '40px' }">
      <div class="col">
        <h4>Resources</h4>
        <ul>
          <li><a href="https://s2024.siggraph.org" target="_blank">SIGGRAPH 2024</a></li>
          <li><a href="https://s2024.siggraph.org/program/student-volunteers/" target="_blank">Frequently Asked
              Questions</a></li>
        </ul>
        <p>
          <a href="https://www.facebook.com/SIGGRAPHStudentVolunteers" target="_blank"><img src="../assets/facebook.png"
              width="30px" /></a>
          <a href="https://twitter.com/siggraphsv" target="_blank"><img src="../assets/twitter.png" width="30px" /></a>
        </p>
      </div>
    </div>
  </b-card>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import router from '@/router'

export default {
  name: 'SvAppStatus',
  data () {
    return {}
  },
  methods: {
    goToConfirmationForm (e) {
      e.preventDefault()
      router.push('/confirmation')
    },
    declineAcceptance (e) {
      e.preventDefault()
      this.$store.dispatch('user/declineAcceptance').then(() => {
        // Reload application again to get the new status
        this.$store.dispatch('application/load')
      })
    }
  },
  computed: {
    ...mapGetters(['isAfterConfirmationDeadline']),
    ...mapGetters('application', ['isNewApp', 'isNotNewApp', 'isPending', 'isAccepted', 'isOffered', 'isDeclined']),
    ...mapState('application', ['isLoaded', 'isLoading', 'completed']),
    ...mapState('user', ['profile', 'isTeamLeader']),
    TLName () {
      if (this.profile.nickname === '') {
        return this.profile.firstName !== '' ? this.profile.firstName : 'Team Leader'
      } else {
        return this.profile.nickname
      }
    },
    SVName () {
      if (this.profile.nickname === '') {
        return this.profile.firstName !== '' ? this.profile.firstName : 'SV'
      } else {
        return this.profile.nickname
      }
    }
  },
  created: function () {
    if (!this.$store.state.application.isLoaded) {
      this.$store.dispatch('application/load')
    }
    if (!this.$store.state.user.loadedAttributes) {
      this.$store.dispatch('user/loadAttributes')
    }
  }
}
</script>

<style scoped>
.card {
  margin: 10px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/AppStatus.vue